import { StatePanel } from '@sakhtar/design-system/react';

/**
 * Every module beyond Auth is built in its own batch, against the "NEW
 * CLIENT ROUTE" contract in docs/agents/customer-delivery-ui-route-inventory.md
 * — this placeholder exists so the route tree is complete and honest (a real
 * "not built yet" state, not a 404) rather than a stand-in for any single
 * screen's design.
 */
export function AdminShellPlaceholder() {
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <StatePanel
        variant="route_not_available"
        title="این بخش هنوز آماده نیست"
        description="این بخش به‌زودی در دسترس قرار می‌گیرد."
      />
    </div>
  );
}
